import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			name: "landing",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 5},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/home",
			name: "home",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 100},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/about",
			name: "about",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 200},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/experience",
			name: "experience",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 300},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/education",
			name: "education",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 400},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/skills",
			name: "skills",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 500},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/projects",
			name: "projects",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 600},
				footer: {backgroundColor: "black"},
			},
		},
		{
			path: "/achievements",
			name: "achievements",
			components: {default: Home, header: MainNavbar, footer: MainFooter},
			props: {
				header: {colorOnScroll: 700},
				footer: {backgroundColor: "black"},
			},
		},
	],
	scrollBehavior: (to) => {
		if (to.hash) {
			return {selector: to.hash};
		} else {
			return {x: 0, y: 0};
		}
	},
});
